import { render, staticRenderFns } from "./BanknoteAvatarDialog.vue?vue&type=template&id=f9166082&scoped=true"
import script from "./BanknoteAvatarDialog.vue?vue&type=script&lang=js"
export * from "./BanknoteAvatarDialog.vue?vue&type=script&lang=js"
import style0 from "./BanknoteAvatarDialog.vue?vue&type=style&index=0&id=f9166082&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9166082",
  null
  
)

export default component.exports